import React from "react";

interface Props {
  isActive: boolean;
  isLarge?: boolean;
}

export default function EmailIcon({ isActive, isLarge = false }: Props) {
  return (
    <svg
      width={isLarge ? "48" : "24"}
      height={isLarge ? "48" : "24"}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="24" fill="#9DCD5A" />
      <path
        d="M13.5 20.6699V29.2499C13.5 30.0456 13.8161 30.8086 14.3787 31.3712C14.9413 31.9339 15.7044 32.2499 16.5 32.2499H31.5C32.2956 32.2499 33.0587 31.9339 33.6213 31.3712C34.1839 30.8086 34.5 30.0456 34.5 29.2499V20.6699L25.572 26.1629C25.0992 26.4538 24.5551 26.6078 24 26.6078C23.4449 26.6078 22.9008 26.4538 22.428 26.1629L13.5 20.6699Z"
        fill="#F9FFF1"
      />
      <path
        d="M34.5 18.908V18.75C34.5 17.9544 34.1839 17.1913 33.6213 16.6287C33.0587 16.0661 32.2956 15.75 31.5 15.75H16.5C15.7044 15.75 14.9413 16.0661 14.3787 16.6287C13.8161 17.1913 13.5 17.9544 13.5 18.75V18.908L23.214 24.886C23.4504 25.0314 23.7225 25.1084 24 25.1084C24.2775 25.1084 24.5496 25.0314 24.786 24.886L34.5 18.908Z"
        fill="#F9FFF1"
      />
    </svg>
  );
}
